/* SpacePicker.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1rpy%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1ule%7Bdisplay%3Ablock%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._6rth1b66%7Bmargin-block-end%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pfhidpf%7Bmargin-block-start%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._k48p1pd9%7Bfont-weight%3Avar(--ds-font-weight-semibold%2C600)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._11c8wadc%7Bfont%3Avar(--ds-font-body-small%2Cnormal%20400%209pt%2F1pc%20%22Atlassian%20Sans%22%2Cui-sans-serif%2C-apple-system%2CBlinkMacSystemFont%2C%22Segoe%20UI%22%2CUbuntu%2C%22Helvetica%20Neue%22%2Csans-serif)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvx1v1w%3Ahover%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhki8nm%7Bbackground-color%3Avar(--ds-background-neutral%2C%230515240f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1h6d1v1w%7Bborder-color%3Avar(--ds-border-focused%2C%234688ec)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._irr315s3%3Ahover%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk15s3%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._irr3plhp%3Ahover%7Bbackground-color%3Avar(--ds-background-neutral-hovered%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvx1j28%3Ahover%7Bborder-color%3Atransparent%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozgutpp%7Bpadding-inline-start%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3ickbl%7Bheight%3A3pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1j9a%7Bbackground-color%3Avar(--ds-background-input%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._80omtlke%7Bcursor%3Apointer%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1h6d1l7x%7Bborder-color%3Avar(--ds-border%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko12b0%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D");
import { Fragment, useCallback, useEffect, useMemo, useRef } from 'react';
import Avatar from '@atlaskit/avatar';
import { getDocument } from '@atlaskit/browser-apis';
import { Flex } from '@atlaskit/primitives/compiled';
import type { CSSObjectWithLabel } from '@atlaskit/react-select';
import { AsyncSelect, ControlProps, type OptionType, components } from '@atlaskit/select';
import { layers } from '@atlaskit/theme';
import { ApplicationEdition } from '@atlassian/invite-people/types';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { cx } from '@compiled/react';
// eslint-disable-next-line @townsquare/rules/no-define-messages -- Legacy defineMessages usage; migrate under TC-48428
import { defineMessages, useIntl } from 'react-intl';
import { graphql, useFragment } from 'react-relay';
import { useAnalytics } from '@townsquare/analytics';
import { useSpaceSearch, createSpaceOption, shouldIncludeProject, buildProjectOptions } from '../../hooks/useSpaceSearch';
import { JiraSpaceOption, SpaceSelectOption } from '../../types/SpaceInputTypes';
import type { SpacePicker_data$key, SpacePicker_data$data } from './__generated__/SpacePicker_data.graphql';
export type SpacePickerProps = {
  selectedSpace: JiraSpaceOption | undefined;
  onSelectSpace: (space: JiraSpaceOption | undefined) => void;
  data: SpacePicker_data$key;
  cloudId: string;
  appEdition: ApplicationEdition;
};
const messages = defineMessages({
  spaceSelectLabel: {
    id: 'townsquare.invite-people-modal.space-picker.space-select-label',
    defaultMessage: "Select which Jira space they'll be added to",
    description: 'The label for a dropdown component which allows the user to select the space the invited person will be added to.'
  },
  noSpaceOptionsMessage: {
    id: 'townsquare.invite-user-modal.space-picker.no-space-options-message',
    defaultMessage: 'There are no Jira spaces that you can add people to. Please check your permissions',
    description: 'The message displayed when no spaces are found in the space picker.'
  }
});
const buildRecommendedOptions = (recommendations: NonNullable<SpacePicker_data$data['smarts']>['recommendedContainerV2'], appEdition: ApplicationEdition): SpaceSelectOption[] => recommendations?.flatMap(rec => {
  const container = rec?.container;
  if (!container?.name || !container.projectId || !container.key) return [];
  const projectStyle = container?.projectStyle;
  if (!shouldIncludeProject(container.projectType, projectStyle, appEdition)) return [];
  return [createSpaceOption({
    projectId: container.projectId,
    key: container.key,
    name: container.name,
    projectType: container.projectType,
    projectStyle: container.projectStyle,
    avatarUrl: container.avatar?.medium,
    source: 'recommendation'
  })];
}) ?? [];
const controlStyles = {
  root: "_2rko12b0 _1h6d1l7x _80omtlke _bfhk1j9a _4t3ickbl _bozgutpp _4cvx1j28 _irr3plhp",
  menuIsOpen: "_bfhk15s3 _irr315s3",
  focused: "_1h6d1v1w _bfhki8nm _4cvx1v1w",
  label: "_11c8wadc _k48p1pd9 _1pfhidpf _6rth1b66 _1e0c1ule _syaz1rpy"
};
const formatOptionLabel = (option: OptionType) => {
  const avatar = option.data.avatarUrls?.['24x24'];
  return <Flex gap="space.100">
			<Avatar src={avatar} size="xsmall" />
			<span>{option.data.name}</span>
		</Flex>;
};
const CustomControl = (props: ControlProps<SpaceSelectOption>) => <components.Control {...props} xcss={cx(controlStyles.root, props.isFocused && controlStyles.focused, props.menuIsOpen && controlStyles.menuIsOpen)} />;
export const SpacePicker = ({
  selectedSpace,
  onSelectSpace,
  data: dataRef,
  cloudId,
  appEdition
}: SpacePickerProps) => {
  const {
    formatMessage
  } = useIntl();
  const hasInitialised = useRef(false);
  const analytics = useAnalytics();
  const data = useFragment<SpacePicker_data$key>(graphql`
			fragment SpacePicker_data on Query
			@argumentDefinitions(
				cloudId: { type: "ID!" }
				userId: { type: "String!" }
				tenantId: { type: "String!" }
				first: { type: "Int", defaultValue: 20 }
			) {
				jira {
					allJiraProjects(
						cloudId: $cloudId
						filter: {
							sortBy: { order: DESC, sortBy: LAST_ISSUE_UPDATED_TIME }
							types: [BUSINESS, SOFTWARE]
							keyword: ""
						}
						first: $first
					) {
						edges {
							node {
								projectId
								name
								key
								avatar {
									medium
								}
								projectType
								projectStyle
							}
						}
					}
				}
				smarts {
					recommendedContainerV2(
						recommendationsQuery: {
							context: { userId: $userId, tenantId: $tenantId, product: "jira" }
							modelRequestParams: { caller: "team-invite-people", experience: "CgContainerNearbyUser" }
							requestingUserId: "context"
							maxNumberOfResults: 10
						}
					) {
						container {
							... on JiraProject {
								projectId
								name
								key
								avatar {
									medium
								}
								projectType
								projectStyle
							}
						}
					}
				}
			}
		`, dataRef);
  const options = useMemo(() => {
    const recommendedProjects = buildRecommendedOptions(data.smarts?.recommendedContainerV2, appEdition);
    const excludeIds = new Set(recommendedProjects.map(opt => opt.value));
    const nodes = data.jira?.allJiraProjects?.edges?.map(e => e?.node);
    const allProjectOptions = buildProjectOptions(nodes, appEdition, excludeIds, 'project-list');
    return [...recommendedProjects, ...allProjectOptions].slice(0, 10);
  }, [data.jira?.allJiraProjects?.edges, data.smarts?.recommendedContainerV2, appEdition]);
  const handleChange = useCallback((newValue: SpaceSelectOption | null) => {
    onSelectSpace(newValue ? newValue.data : undefined);
    if (newValue) {
      void analytics.ui('option', 'selected', {
        selectedSpace: newValue.data.key,
        projectType: newValue.data.projectTypeKey,
        source: newValue.data.source,
        appEdition
      }, 'spacePicker');
    } else {
      void analytics.ui('option', 'cleared', {
        appEdition
      }, 'spacePicker');
    }
  }, [onSelectSpace, analytics, appEdition]);
  useEffect(() => {
    if (hasInitialised.current) {
      return;
    }
    hasInitialised.current = true;
    if (options.length > 0) {
      onSelectSpace(options[0].data);
      void analytics.ui('option', 'selected', {
        defaultSelected: true,
        selectedSpace: options[0].data.key,
        projectType: options[0].data.projectTypeKey,
        source: options[0].data.source,
        appEdition
      }, 'spacePicker');
    }
    void analytics.track('spacePicker', 'loaded', {
      recommendedSpaceCount: data.smarts?.recommendedContainerV2?.length ?? 0,
      allSpacesCount: data.jira?.allJiraProjects?.edges?.length ?? 0,
      appEdition
    });
  }, [options, onSelectSpace, analytics, cloudId, data, appEdition]);
  const loadOptions = useSpaceSearch({
    cloudId,
    appEdition,
    defaultOptions: options
  });
  if (options.length === 0 && !hasInitialised.current) {
    return null;
  }
  return <Fragment>
			<label id="space-picker-input-label" className={ax([controlStyles.label])}>
				{formatMessage(messages.spaceSelectLabel)}
			</label>
			<AsyncSelect closeMenuOnSelect isClearable isSearchable loadOptions={loadOptions} defaultOptions={options} value={selectedSpace ? {
      label: selectedSpace.name,
      value: selectedSpace.id,
      data: selectedSpace
    } : null} onChange={handleChange} noOptionsMessage={() => formatMessage(messages.noSpaceOptionsMessage)} components={{
      Control: CustomControl
    }} formatOptionLabel={formatOptionLabel} inputId="space-picker-input" labelId="space-picker-input-label" menuPortalTarget={getDocument()?.body} styles={{
      menuPortal: base => ({
        ...base,
        zIndex: layers.modal()
      } as CSSObjectWithLabel)
    }} />
		</Fragment>;
};